export const COLOR_SCHEMES = ["light", "dark"] as const;

export type ColorScheme = (typeof COLOR_SCHEMES)[number];

const STORAGE_KEY = "play-card.color-scheme";

function isColorScheme(raw: string | null | undefined): raw is ColorScheme {
	return (COLOR_SCHEMES as readonly string[]).includes(raw ?? "");
}

export function parseColorScheme(raw: string | null | undefined): ColorScheme {
	return isColorScheme(raw) ? raw : "light";
}

export function readStoredCardScheme(): ColorScheme {
	if (typeof localStorage === "undefined") {
		return "light";
	}
	return parseColorScheme(localStorage.getItem(STORAGE_KEY));
}

export function persistCardScheme(scheme: ColorScheme): void {
	if (typeof localStorage === "undefined") {
		return;
	}
	localStorage.setItem(STORAGE_KEY, scheme);
}
